import React from 'react';
import PaginatedItems from 'presentation/components/organisms/PaginatedItems';

function Results({ meeting }) {
  return (
    <div className='mt-4 mb-5'>
      {meeting.recordings.length ? (
        <PaginatedItems items={meeting.recordings} itemsPerPage={10} />
      ) : (
        <div className='mt-4 mb-5'>
          <div className='list-container'>
            <div className='list-items flex flex-col sm:flex-row items-center justify-between max-w-2xl mx-auto border-2 border-gray-500 hover:border-green-500 rounded-md my-1 px-5 py-5 p-12'>
              <div className='flex flex-row items-center'>
                <h1 className='tracking-tight dark:text-gray-100 text-center'>
                  ¡La Clase con id {meeting.meeting.id} no tiene grabaciones
                  disponibles!
                </h1>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Results;
